import { useState, useCallback } from 'react';

export default function useInput(defaultValue) {
  const [input, setInput] = useState(defaultValue);

  const onChange = useCallback((e) => {
    if (e?.target) setInput(e.target.value);
    else setInput(e);
  }, []);
  const onReset = useCallback(() => setInput(""), []);
  return [input, onChange, onReset]
}